import { useUser } from '@/app/context/user';
import { cn } from '@/app/lib/utils';
import Image from 'next/image';
import { forwardRef, useImperativeHandle } from 'react';
import Icon from '../ui/Icon';
import { Client } from '@/types/client';

type ClientLogoProps = {
  size?: number;
  className?: string;
  fallbackClassName?: string;
  client?: Client;
};

export type ClientLogoRef = {
  getLogo: () => string;
};

const ClientLogo = forwardRef<ClientLogoRef, ClientLogoProps>(
  ({ size = 44, className, fallbackClassName, client: providedClient }, ref) => {
    const { client: contextClient } = useUser();
    const client = providedClient || contextClient;

    const logo = client?.logo || '';

    useImperativeHandle(ref, () => ({
      getLogo: () => logo,
    }));

    if (!logo) {
      return (
        <div
          className={cn(
            'w-10 h-10 bg-border rounded-md flex items-center justify-center',
            fallbackClassName
          )}
        >
          <Icon name="building-4-line" size={5} className="text-muted-foreground" />
        </div>
      );
    }

    return (
      <Image src={logo} alt={client?.name || ''} width={size} height={size} className={className} />
    );
  }
);

ClientLogo.displayName = 'ClientLogo';

export default ClientLogo;
